// react
import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom'
// components
import { Button, Icon, Label, Input, Table, Popup } from "semantic-ui-react";
// others
import moment from "moment";

// component
const BasketItem = ({
    as,
    item,
    index,
    items,
    setItems,
    removeProductFromBasket,
    removeItemFromView,
}) => {
    const [amount, setAmount] = useState(items.find(basketItem => basketItem.id === item.id)?.amount || 1)

    const removeItem = (item) => {
        removeProductFromBasket(item);

        if (removeItemFromView) {
            removeItemFromView(item);
        }
    };

    const handleAction = (action, custom) => {
        custom = custom || 1

        if (action === "custom") {
            if (custom > 0) {
                setItems(prev => prev.map(basketItem => {
                    if (basketItem.id === item.id) {
                        basketItem.amount = custom
                    }
                    return basketItem
                }))
                setAmount(custom)
            } else {
                removeItem(item)
            }
        }
        if (action === "increment") {
            setItems(prev => prev.map(basketItem => {
                if (basketItem.id === item.id) {
                    basketItem.amount = basketItem.amount + 1
                }

                return basketItem
            }))

            setAmount(prev => prev + 1)
        }
        if (action === "decrement") {
            if ((amount - 1) > 0) {
                setItems(prev => prev.map(basketItem => {
                    if (basketItem.id === item.id) {
                        basketItem.amount = basketItem.amount - 1
                    }
                    return basketItem
                }))
                setAmount(prev => prev - 1)
            } else {
                removeItem(item)
            }
        }
    }

    useEffect(() => {
        setItems(prevState => prevState.filter(basketItem => {
            if (basketItem.id === item.id) {
                basketItem.amount = amount
            }

            return basketItem
        }))
        // eslint-disable-next-line
    }, [amount])

    // template
    return as === "tableCell" ? (
        <Table.Row verticalAlign="middle" style={{ borderBottom: "1px solid lightgrey" }} key={item.id}>
            <Table.Cell>
                {index + 1}.
            </Table.Cell>
            <Table.Cell>
                <h4>
                    <Popup
                        trigger={
                            <Link style={{ color: "#d60d8c" }} to={`/activity/${item.id}/detail`} target="_blank">{item.name}</Link>
                        }
                        content={
                            <div>
                                <Label style={{ marginBottom: "0.5rem" }} color={
                                    item.event_type === "future"
                                        ? "green"
                                        : item.event_type === "solidarity"
                                            ? "blue"
                                            : "pink"
                                }>
                                    {
                                        item.event_type === "future"
                                            ? "#APfuture"
                                            : item.event_type === "solidarity"
                                                ? item.is_highlighted ? "#APsolidarity - event" : "#APsolidarity"
                                                : "#APbusiness"
                                    }
                                </Label>
                                <div>

                                    <p>
                                        <Icon name="map marker alternate" size="small" />{" "}
                                        <span>
                                            {item.address}
                                        </span>
                                    </p>
                                    <p>
                                        {item.starts &&
                                            <>
                                                <Icon name="clock outline" />{" "}
                                                <span>
                                                    {moment(item.starts).utc().format("DD.MM.YYYY HH:mm")}
                                                </span>
                                            </>
                                        }
                                        {(item.event_type === "solidarity" && item.is_paid === true) &&
                                            <>
                                                <br />
                                                <Icon
                                                    name="circle info"
                                                    color="blue"
                                                    style={{
                                                        fontWeight: 'bold',
                                                        color: 'black',
                                                    }}
                                                />
                                                Dobrovoľný príspevok
                                            </>
                                        }
                                    </p>


                                </div>
                            </div>
                        }
                    />
                    {item.is_discounted && (
                        <Label
                            style={{ marginLeft: "2rem" }}
                            color="green"
                            size="tiny"
                            tag
                        >
                            Zľavnený
                        </Label>
                    )}
                </h4>
            </Table.Cell>
            <Table.Cell>
                <Button disabled={item.event_type !== "solidarity"} size="tiny" primary content={" - "} style={{ fontWeight: "bold", background: "transparent", color: "var(--dark)", fontSize: "1.3rem" }} onClick={() => handleAction("decrement")} />
                <Input disabled={item.event_type !== "solidarity"} size="mini" style={{ width: "50px", textAlign: "center", paddingRight: "0.2rem" }} value={amount} onChange={(e, { value }) => handleAction("custom", value)} />
                <Button disabled={item.event_type !== "solidarity"} size="tiny" primary content={" + "} style={{ fontWeight: "bold", background: "transparent", color: "var(--dark)", fontSize: "1.3rem" }} onClick={() => handleAction("increment")} />
            </Table.Cell>
            <Table.Cell>
                <span style={{ fontSize: "1.1rem", fontWeight: "bold", marginRight: "2.5rem" }}>
                    {item.is_discounted && (
                        <>
                            <strike>{parseFloat(item.price * amount).toFixed(2)}</strike>{" "}
                            <span
                                style={{
                                    fontSize: "1rem",
                                    paddingLeft: "1rem",
                                }}
                            >
                                {parseFloat(item.discountPrice * amount).toFixed(2)}{" "}
                                {item.price_type}
                            </span>
                        </>
                    )}
                    {!item.is_discounted && (
                        <>
                            {parseFloat(item.price * amount).toFixed(2)} {item.price_type}
                        </>
                    )}
                </span>
            </Table.Cell>
            <Table.Cell>
                <Button
                    onClick={(event) => removeItem(item)}
                    icon="close"
                    style={{
                        marginLeft: "2rem",
                        padding: "0.5rem 0.8rem",
                        background: "transparent",
                        color: "red",
                        fontWeight: "bold",
                    }}
                />
            </Table.Cell>
        </Table.Row>
    ) : as === "card" ? (
        <div className="basket-item-row">
            <div className="basket-item-main">
                <div className="basket-item-number">{index + 1}.</div>
                <div className="basket-item-content">
                    <div className="basket-item-top">
                        <div className="basket-item-title-group">
                            <Link className="basket-item-title" to={`/activity/${item.id}/detail`} target="_blank">
                                {item.name}
                            </Link>
                            <div className="basket-item-badges">
                                <Label
                                    size="tiny"
                                    color={
                                        item.event_type === "future"
                                            ? "green"
                                            : item.event_type === "solidarity"
                                                ? "blue"
                                                : "pink"
                                    }
                                    className="basket-item-type-label"
                                >
                                    {
                                        item.event_type === "future"
                                            ? "#APfuture"
                                            : item.event_type === "solidarity"
                                                ? item.is_highlighted ? "#APsolidarity - event" : "#APsolidarity"
                                                : "#APbusiness"
                                    }
                                </Label>
                                {item.is_discounted && (
                                    <Label color="green" size="tiny" tag className="basket-item-discount-label">
                                        Zľavnený
                                    </Label>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="basket-item-bottom">
                        {item.address && (
                            <div className="basket-item-info">
                                <Icon name="map marker alternate" size="small" />
                                <span>{item.address}</span>
                            </div>
                        )}
                        {item.starts && (
                            <div className="basket-item-info">
                                <Icon name="clock outline" />
                                <span>{moment(item.starts).utc().format("DD.MM.YYYY HH:mm")}</span>
                            </div>
                        )}
                        {(item.event_type === "solidarity" && item.is_paid === true) && (
                            <div className="basket-item-info basket-item-voluntary">
                                <Icon name="circle info" />
                                <span>Dobrovoľný príspevok</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="basket-item-actions">
                <div className="basket-item-quantity">
                    <Button
                        disabled={item.event_type !== "solidarity"}
                        size="tiny"
                        content=" - "
                        className="basket-item-qty-btn"
                        onClick={() => handleAction("decrement")}
                    />
                    <Input
                        disabled={item.event_type !== "solidarity"}
                        size="mini"
                        className="basket-item-qty-input"
                        value={amount}
                        onChange={(e, { value }) => handleAction("custom", value)}
                    />
                    <Button
                        disabled={item.event_type !== "solidarity"}
                        size="tiny"
                        content=" + "
                        className="basket-item-qty-btn"
                        onClick={() => handleAction("increment")}
                    />
                </div>
                <div className="basket-item-price">
                    {item.is_discounted ? (
                        <>
                            <span className="basket-item-price-old">{parseFloat(item.price * amount).toFixed(2)}</span>
                            <span className="basket-item-price-new">{parseFloat(item.discountPrice * amount).toFixed(2)} {item.price_type}</span>
                        </>
                    ) : (
                        <span className="basket-item-price-current">{parseFloat(item.price * amount).toFixed(2)} {item.price_type}</span>
                    )}
                </div>
                <Button
                    onClick={(event) => removeItem(item)}
                    icon="close"
                    className="basket-item-remove"
                />
            </div>
        </div>
    ) : (
        <div style={{
            padding: "1.5rem",
            marginBottom: "1rem",
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            background: "#fff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
        }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", alignItems: "baseline", marginBottom: "0.75rem" }}>
                        <span style={{
                            fontSize: "1.1rem",
                            color: "#666",
                            marginRight: "0.5rem"
                        }}>
                            {index + 1}.
                        </span>
                        <Link
                            style={{
                                color: "#d60d8c",
                                fontSize: "1.1rem",
                                fontWeight: "600",
                                textDecoration: "none"
                            }}
                            to={`/activity/${item.id}/detail`}
                            target="_blank"
                        >
                            {item.name}
                        </Link>
                    </div>
                    <div style={{ marginLeft: "1.5rem" }}>
                        <div style={{ fontSize: "0.9rem", color: "#555" }}>
                            <div style={{ marginBottom: "0.3rem" }}>
                                <Icon name="map marker alternate" size="small" />
                                <span style={{ marginLeft: "0.3rem" }}>{item.address}</span>
                            </div>
                            {item.starts && (
                                <div style={{ marginBottom: "0.3rem" }}>
                                    <Icon name="clock outline" size="small" />
                                    <span style={{ marginLeft: "0.3rem" }}>
                                        {moment(item.starts).utc().format("DD.MM.YYYY HH:mm")}
                                    </span>
                                </div>
                            )}
                            <div style={{ fontSize: "1.3rem", fontWeight: "bold", color: "#333", marginTop: "2rem" }}>
                                <Icon name="money bill alternate outline" size="small" style={{ marginRight: "0.5rem" }} />
                                {item.is_discounted ? (
                                    <div style={{ textAlign: "right" }}>
                                        <div>
                                            <strike style={{ color: "#999", fontSize: "1rem" }}>
                                                {parseFloat(item.price * (amount || 1)).toFixed(2)}
                                            </strike>
                                        </div>
                                        <div style={{ color: "#d60d8c" }}>
                                            {parseFloat(item.discountPrice * (amount || 1)).toFixed(2)} {item.price_type}
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        {parseFloat(item.price * (amount || 1)).toFixed(2)} {item.price_type}
                                    </div>
                                )}
                            </div>
                            {(item.event_type === "solidarity" && item.is_paid === true) && (
                                <div>
                                    <Icon name="circle info" color="blue" size="small" />
                                    <span style={{ marginLeft: "0.3rem" }}>Dobrovoľný príspevok</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "0.5rem" }}>
                    <Button
                        onClick={() => removeItem(item)}
                        icon="close"
                        size="small"
                        style={{
                            background: "transparent",
                            color: "#dc143c",
                            padding: "0.5rem",
                            fontSize: "1.3rem"
                        }}
                    />

                </div>
            </div>
            {item.event_type === "solidarity" && (
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "1rem",
                    paddingTop: "1rem",
                    borderTop: "1px solid #f0f0f0",
                    marginLeft: "1.5rem"
                }}>
                    <Button
                        size="tiny"
                        content=" - "
                        style={{
                            fontWeight: "bold",
                            background: "transparent",
                            color: "var(--dark)",
                            fontSize: "1.3rem"
                        }}
                        onClick={() => handleAction("decrement")}
                    />
                    <Input
                        size="mini"
                        style={{ width: "50px", textAlign: "center", margin: "0 0.5rem" }}
                        value={amount}
                        onChange={(e, { value }) => handleAction("custom", value)}
                    />
                    <Button
                        size="tiny"
                        content=" + "
                        style={{
                            fontWeight: "bold",
                            background: "transparent",
                            color: "var(--dark)",
                            fontSize: "1.3rem"
                        }}
                        onClick={() => handleAction("increment")}
                    />
                </div>
            )}
        </div>
    );
};

export default BasketItem;
